import './FacetGroupTitle.scss';
import React from 'react';
import {useDispatch} from 'react-redux';
import {collapseFilterGroup, expandFilterGroup} from '../../../duck/filter.actions';
import classNames from 'clsx';
import {SvgIcon} from '../../../../icons/svgIcon';
import {Icons} from '../../../../icons/icons';
import {buildDefaultFieldTitle} from '../../../../utils/utils';
import {useTranslation} from 'react-i18next';
import {FilterWidget} from '../../../../common/filterWidget/filterWidget';

type InputProps = {
    fieldName: string;
    isExpanded: boolean;
    isSearchable: boolean;
    searchTerm: string;
    setSearchTerm: (filter: string) => void;
};

export const FacetGroupTitle = React.memo(({
                                               fieldName,
                                               isExpanded,
                                               isSearchable,
                                               searchTerm,
                                               setSearchTerm
                                           }: InputProps) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const title = t('fieldTitle.' + fieldName + '.label', buildDefaultFieldTitle(fieldName));
    const alt = isExpanded ? t('facets.icon.collapse') : t('facets.icon.expand');

    const onToggleExpand = () => {
        isExpanded ? dispatch(collapseFilterGroup(fieldName)) : dispatch(expandFilterGroup(fieldName));
    };

    return (
        <button onClick={onToggleExpand} className={classNames('list-group-item-title-wrapper')}>
            <div className="list-group-item-title">
                <SvgIcon
                    icon={Icons.CHEVRON_DOWN}
                    alt={alt}
                    className={classNames(isExpanded ? 'facet-group-expanded' : '')}
                />
                {title}
            </div>
            {isExpanded && isSearchable && (
                <FilterWidget filter={searchTerm} setFilter={setSearchTerm} title={title}/>
            )}
        </button>
    );
});
